module.exports = __webpack_public_path__ + "media/components/star-rating/static/white/5-ed24aa6753a590f98a58dcfadce78ccc.svg";